export const MakeDeepCopy = (toCopy) => {
    return JSON.parse(JSON.stringify(toCopy));
}